'use strict';

var StrategyListingTransformerFactory = function StrategyListingTransformerFactory(DataTransformer, momentService, UserProcessingTransformationService) {
  function StrategyListingTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['strategy-listing', 'alert-strategy-listing'];
    this.priority = 1;
  }
  StrategyListingTransformer.prototype = Object.create(DataTransformer.prototype);
  StrategyListingTransformer.constructor = StrategyListingTransformer;
  StrategyListingTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType.indexOf(sourceType) !== -1;
  };
  StrategyListingTransformer.prototype.isCacheable = function () {
    return true;
  };
  StrategyListingTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  StrategyListingTransformer.prototype.transform = function (data) {
    var result = data && data.domain && data.domain.results || [];
    for (var i = 0; i < result.length; i++) {
      var obj = result[i];
      obj.lastUpdatedAt = momentService.of(obj.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT);
      obj.createdDate = momentService.of(obj.createdDate, momentService.FIELD.CREATED_DATE);
      obj.eventTimeStamp = momentService.of(obj.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
      obj.lastUsedAt = momentService.of(obj.lastUsedAt, momentService.FIELD.LAST_USED_AT);
      obj.createdByDisplayName = UserProcessingTransformationService.getUserDisplayName(obj.createdBy);
      obj.lastUpdatedByDisplayName = UserProcessingTransformationService.getUserDisplayName(obj.lastUpdatedBy);
    }
    return result;
  };
  return StrategyListingTransformer;
};
StrategyListingTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = StrategyListingTransformerFactory;